import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { Check, MailIcon, UserCheck, UserX, X } from 'lucide-react'
import i18n from 'i18next'
import { lazy } from 'react'
const IssuesFiltersDateRangePicker = lazy(
  () =>
    import(
      '@/routes/projectStages/issues/view/filters/issuesFiltersDateRangePicker/IssuesFiltersDateRangePicker.tsx'
    ),
)

export const deadlineProperty: PopoverProperty = {
  label: 'component',
  value: 'deadline',
  component: <IssuesFiltersDateRangePicker nested filterKey={'deadline'} />,
}

export const updatedAtProperty: PopoverProperty = {
  label: 'component',
  value: 'updatedAt',
  component: <IssuesFiltersDateRangePicker nested filterKey={'updatedAt'} />,
}

export const createdAtProperty: PopoverProperty = {
  label: 'component',
  value: 'createdAt',
  component: <IssuesFiltersDateRangePicker nested filterKey={'createdAt'} />,
}

export const recipientsProperty: PopoverProperty = {
  label: i18n.t(`project.issues.dialog.recipient`),
  value: 'recipients',
  icon: <UserX className={`size-4`} />,
  parent: 'recipients',
}

export const creatorsProperty: PopoverProperty = {
  label: i18n.t(`project.issues.creator`),
  value: 'creators',
  icon: <UserCheck className={`size-4`} />,
  parent: 'creators',
}

export const clearFiltersProperty: PopoverProperty = {
  label: i18n.t(`project.issues.clearFilters`),
  value: `clearFilters`,
  icon: <X className={`size-4`} />,
}

export const notFoundProperty = {
  label: i18n.t('error.notFound'),
  value: '',
  icon: <X />,
}
/**
 * A function, not a constant: this module is imported before i18next has loaded
 * a language, so a label resolved at module scope freezes whatever the fallback
 * bundle happened to hold. The previous constant sidestepped that by hardcoding
 * Polish, which is why this option never translated.
 */
export const mailInviteProperty = (email: string): PopoverProperty => ({
  // Naming the address is the whole point, and the only caller reaches this
  // option after its own regex accepted what was typed — so there is no
  // address-less variant to fall back to.
  label: i18n.t('projects.details.newUserDialog.inviteThisAddress', { email }),
  value: 'externalInvite',
  icon: <MailIcon className={`size-4`} />,
})

/**
 * The empty state of an invite search. `notFoundProperty` only says that nothing
 * matched, which leaves the caller with no idea that typing a full address is the
 * way forward — so this one names the next step instead. A function for the same
 * reason as above: the label must be resolved after i18next has a language.
 */
export const notFoundInviteProperty = (): PopoverProperty => ({
  label: i18n.t('error.notFound'),
  // On its own line, because the option's label truncates at 260px: the
  // instruction has to survive on a narrow popover, so it gets its own short
  // line instead of one long sentence that ends in an ellipsis.
  description: i18n.t('projects.details.newUserDialog.typeEmailToInvite'),
  value: '',
  icon: <MailIcon className={`size-4`} />,
})

export const selectAllProperty: PopoverProperty = {
  label: i18n.t('common.selectAll'),
  value: 'select-all',
  icon: <Check className={`size-4`} />,
}
